import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import styled from 'styled-components';
import VxConsultLogo from './VxConsultLogo';
import VxCargaCampos, { pendenciasCarga } from './VxCargaCampos';

/**
 * Renovação de uma pesquisa vencida do mesmo conjunto: a VX só precisa da mercadoria e da faixa de valor.
 */
const ProgramacaoHavanVxModal = ({
  show,
  row,
  loading,
  reason,
  opcoesCarga,
  carregandoOpcoes,
  erroOpcoes,
  onClose,
  onSubmit
}) => {
  const [carga, setCarga] = useState({});

  useEffect(() => {
    if (show) setCarga({});
  }, [row, show]);

  const pendencias = pendenciasCarga(carga, opcoesCarga?.faixas_valor);

  const handleSubmit = event => {
    event.preventDefault();
    if (pendencias > 0 || loading) return;
    onSubmit({ tipo_mercadoria: carga.tipo_mercadoria, valor: carga.valor, valor_carga: carga.valor_carga });
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" backdrop={loading ? 'static' : true} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton={!loading}>
          <HeaderContent>
            <Modal.Title>Renovar consulta VX</Modal.Title>
            <VxConsultLogo size="sm" />
          </HeaderContent>
        </Modal.Header>
        <Modal.Body>
          <ModalMessage>
            A pesquisa deste conjunto está fora da validade. Informe a carga para renová-la na VX.
          </ModalMessage>

          {reason ? <ReasonText>{reason}</ReasonText> : null}

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>CPF</Form.Label>
                <Form.Control size="sm" value={row?.cpf || ''} disabled />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Placas</Form.Label>
                <Form.Control size="sm" value={(row?.placas || []).join(', ')} disabled />
              </Form.Group>
            </Col>
          </Row>

          <VxCargaCampos
            opcoes={opcoesCarga}
            carregando={carregandoOpcoes}
            erro={erroOpcoes}
            valores={carga}
            onChange={setCarga}
            disabled={loading}
          />
        </Modal.Body>
        <Modal.Footer>
          <ButtonWithLoading variant="outline-secondary" type="button" onClick={onClose} disabled={loading}>
            Cancelar
          </ButtonWithLoading>
          <ButtonWithLoading variant="primary" type="submit" disabled={pendencias > 0} loading={loading} loadingText="Enviando...">
            Renovar consulta
          </ButtonWithLoading>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

ProgramacaoHavanVxModal.propTypes = {
  show: PropTypes.bool,
  row: PropTypes.shape(),
  loading: PropTypes.bool,
  reason: PropTypes.string,
  opcoesCarga: PropTypes.shape(),
  carregandoOpcoes: PropTypes.bool,
  erroOpcoes: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

ProgramacaoHavanVxModal.defaultProps = {
  show: false,
  row: null,
  loading: false,
  reason: '',
  opcoesCarga: null,
  carregandoOpcoes: false,
  erroOpcoes: ''
};

export default ProgramacaoHavanVxModal;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  padding-right: 16px;
`;

const ModalMessage = styled.div`
  margin-bottom: 8px;
  color: #24344d;
  font-size: 15px;
  font-weight: 600;
`;

const ReasonText = styled.div`
  margin-bottom: 18px;
  color: #6c757d;
  font-size: 13px;
`;
